import * as React from 'react';
import styles from './PinLink.module.css';
import { useSelector } from 'react-redux';
import { selectDigitalMap } from 'ducks/universal/digitalMap';
import { useUrlQueryDisplayState } from 'components/Map/useUrlQueryDisplayState';
import { smoothMoveCamera } from 'components/Map/mapUtils';
import MapDisplayContextService from 'components/Map/MapDisplayContextService';
interface Props {
  pinKey: string;
  children: React.ReactNode;
  onCloseChat: () => void;
}

export const PinLink = ({ pinKey, children, onCloseChat }: Props) => {
  const digitalMap = useSelector(selectDigitalMap);

  const { pushUrlParams } = useUrlQueryDisplayState();

  const pin = digitalMap?.pins.find((pin) => pin.key === pinKey);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    pushUrlParams({ pin: pinKey, pind: 'SUMMARY', nav: 'map' });

    const pin = digitalMap?.pins.find((p) => p.key === pinKey);
    if (pin?.floor_number) {
      MapDisplayContextService.setSelectedFloor(pin?.floor_number);
    }

    onCloseChat();

    smoothMoveCamera(
      MapDisplayContextService.getMapDisplayContext()?.googleMap ?? null,
      MapDisplayContextService.getMapDisplayContext()?.openLayersMap ?? null,
      {
        center: {
          lat: pin?.location?.latitude ?? 0,
          lng: pin?.location?.longitude ?? 0,
        },
      }
    );
  };

  if (!pin) {
    return null;
  }

  return (
    <a onClick={handleClick} className={styles.link}>
      {children}
    </a>
  );
};
